import { FC } from 'react'

import { Table } from 'ui/components'

import { TChanges } from './ChangesProps'

import * as SC from './styles'

export const ChangesTable: FC<{ changes: TChanges[]; dataQa: string }> = ({ changes, dataQa }) => (
  <Table
    columns={[
      {
        title: 'Record',
        key: 'label',
        align: 'left',
        width: '200px'
      },
      {
        title: 'Orbit',
        key: 'from',
        align: 'left'
      },
      {
        title: '',
        key: 'to',
        align: 'left',
        width: '30px',
        render: () => <>→</>
      },
      {
        title: 'SAR',
        key: 'to',
        align: 'left',
        render: ({ to }) =>
          to === '' ? <SC.NewValueRed>'—'</SC.NewValueRed> : <SC.NewValueGreen>{to}</SC.NewValueGreen>
      }
    ]}
    dataSource={changes.map((el) => ({ item: el }))}
    dataQa={`${dataQa}_changes`}
  />
)
